import React, { useState } from 'react';
import { Event, BudgetItem } from '@/types/events';
import { BudgetSummary } from './BudgetManagement/BudgetSummary';
import { Budget, Expense } from '@/types/budget';
import { mockBudget } from '../../data/mockBudgets';
import { ExpenseForm } from './BudgetManagement/ExpenseForm';
import { ExpenseList } from './BudgetManagement/ExpenseList';
import { VendorManagement } from './BudgetManagement/VendorManagement';
import { ProductManagement } from './BudgetManagement/ProductManagement';
import { DocumentManagement } from './BudgetManagement/DocumentManager';

interface BudgetManagementProps {
  event: Event;
  onUpdate: (updatedEvent: Event) => void;
}

export const BudgetManagement: React.FC<BudgetManagementProps> = ({
  event,
  onUpdate,
}) => {
  const [activeTab, setActiveTab] = useState<'budget' | 'vendors' | 'products' | 'documents'>('budget');
  const [budget, setBudget] = useState<Budget>(mockBudget);
  const [showVendorForm, setShowVendorForm] = useState(false);
  // const [vendors, setVendors] = useState<Vendor[]>(() => {

  
  const handleExpenseSubmit = (newExpense: Omit<Expense, 'id' | 'createdAt' | 'updatedAt'>) => {
    const expense: Expense = {
      ...newExpense,
      id: crypto.randomUUID(),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    };

    setBudget(prev => ({
      ...prev,
      expenses: [...prev.expenses, expense],
    }));
  };

  return (
    <div className="max-w-7xl mx-4 pt-4 space-y-6">
    <div className="border-b border-gray-200">
      <nav className="-mb-px flex space-x-8">
        <button type="button"
          onClick={() => setActiveTab('budget')}
          className={`${
            activeTab === 'budget'
              ? 'border-indigo-500 text-indigo-600'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
          } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
        >
          Budget & Expenses
        </button>
        <button type="button"
          onClick={() => setActiveTab('vendors')}
          className={`${
            activeTab === 'vendors'
              ? 'border-indigo-500 text-indigo-600'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
          } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
        >
          Vendor Management
        </button>
        <button type="button"
          onClick={() => setActiveTab('products')}
          className={`${
            activeTab === 'products'
              ? 'border-indigo-500 text-indigo-600'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
          } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
        >
          Product Management
        </button>
        <button type="button"
          onClick={() => setActiveTab('documents')}
          className={`${
            activeTab === 'documents'
              ? 'border-indigo-500 text-indigo-600'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
          } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
        >
          Supporting Documents
        </button>
      </nav>
    </div>

    {activeTab === 'budget' ? (
      <>
        <BudgetSummary budget={budget} />
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-1">
            <ExpenseForm 
              onSubmit={handleExpenseSubmit}
              onAddVendor={() => setShowVendorForm(true)}
            />
          </div>
          <div className="lg:col-span-2">
            <ExpenseList expenses={budget.expenses} />
          </div>
        </div>
      </>
    ) : 
      activeTab === 'vendors' ? (
        <div className="bg-white rounded-lg shadow-md p-6">
          <VendorManagement />
        </div>
    ) : activeTab === 'products' ? (
      <div className="bg-white rounded-lg shadow-md p-6">
        <ProductManagement />
      </div>
    ) : activeTab === 'documents' ? (
      <div className="bg-white rounded-lg shadow-md p-6">
        <DocumentManagement />
      </div>
    ) : null
  }

    {/* {activeTab === 'budget' ? (
      <>
        <BudgetSummary budget={budget} />
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-1">
            <ExpenseForm 
              onSubmit={handleExpenseSubmit}
              onAddVendor={() => setShowVendorForm(true)}
            />
          </div>
          <div className="lg:col-span-2">
            <ExpenseList expenses={budget.expenses} />
          </div>
        </div>
      </>
    ) : activeTab === 'vendors' ? (
      <div className="bg-white rounded-lg shadow-md p-6">
        <VendorManagement />
      </div>
    ) : activeTab === 'products' ? (
      <div className="bg-white rounded-lg shadow-md p-6">
        <ProductManagement />
      </div>
    ) : activeTab === 'documents' ? (
      <div className="bg-white rounded-lg shadow-md p-6">
        <DocumentManagement />
      </div>
    ) : null
    } */}
  </div>
  );
};